import { gql } from '@apollo/client';
import { useCreate } from '../../utils/useUpdateCreate';
import {
  AttributeCreationInput,
  CreateAttributeMutation,
} from '../../__generated__/queries-web';
import { GET_ATTRIBUTES } from '../queries/getAttributes.web.graphql';

const CREATE_ATTRIBUTE = gql`
  mutation CreateAttribute($data: AttributeCreationInput!) {
    createAttribute(data: $data) {
      id
    }
  }
`;

export const useCreateAttribute = () =>
  useCreate<CreateAttributeMutation, AttributeCreationInput>(CREATE_ATTRIBUTE, [
    GET_ATTRIBUTES,
  ]);
